import React, { Component } from "react";

// Redux
import { connect } from "react-redux";
import { setToast } from "./../../../../redux/actions/toast";
import { showModal } from "../../../../redux/actions/modal";

// Ajax Methods
import ajaxMethods from "../../../../api/ajax-methods";

// Ajax End Points
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";

import { MDBTable, MDBTableBody, MDBTableHead } from "mdbreact";

// UI Components
import { ErrorLoader } from "../../../../UI/Loaders/Loaders";
import { formatMoney } from "../../../../helpers/formatter";
import { appInsights } from "../../../../config/appInsights";

class Disburse extends Component {
  state = {
    disbursementTag: "",
    comment: "",
    error: false,
    funderOptions: [],
    selectedFunder: "",
    selectedDate: "",
    failedApprovedBatchLoans: false,
    successfulApprovedBatchLoans: false,
    failedRejectedBatchLoans: false,
    successfulRejectedBatchLoans: false,
    amountApproved: this.props?.properties?.dataRecord?.loan_amount,
    errorMessage: {},
  };

  inputChangeHandler = (e) => {
    this.setState({
      disbursementTag: e.target.value.trim(),
    });
  };
  componentDidMount() {
    this.getFunderName();
  }

  disburseLoan = (e) => {
    e.preventDefault();
    const { comment, selectedDate, selectedFunder, amountApproved } =
      this.state;

    // let { disbursementSize, disbursementPageNumber } = this.props;
    // let { disbursementSize, disbursementPageNumber } = this.props;

    const { notification, result, loans, resetLoansForDisbursement } =
      this.props.properties;
    if (comment && selectedDate && selectedFunder && amountApproved) {
      const params = {
        loan_ref: this.props.properties.dataRecord.loan_ref,
        comment: comment,
        funder_id: Number(selectedFunder),
        loan_effective_date: selectedDate,
        amount_approved: Number(amountApproved),
      };
      document.querySelector("#disbursement-confirm").classList.add("hidden");
      document.querySelector("#disbursement-loader").classList.remove("hidden");

      ajaxMethods
        .post(ajaxEndpoints.DISBURSE_LOANS, params)
        .then((response) => {
          if (response.status === 200) {
            document
              .querySelector("#disbursement-loader")
              .classList.add("hidden");
            document
              .querySelector("#disbursement-success")
              .classList.remove("hidden");
            result(loans);
            this.props.onCloseModal();
            resetLoansForDisbursement();
            notification("success", response.data.data.data.message);
          } else if (response.status === 400) {
            document
              .querySelector("#disbursement-loader")
              .classList.add("hidden");
            document
              .querySelector("#disbursement-error")
              .classList.remove("hidden");
            result(loans);
            this.props.onCloseModal();
            resetLoansForDisbursement();
            notification("error", response.data.message);
          } else {
            document
              .querySelector("#disbursement-loader")
              .classList.add("hidden");
            document
              .querySelector("#disbursement-error")
              .classList.remove("hidden");
            result(loans);
            this.props.onCloseModal();
            resetLoansForDisbursement();
            notification("error", "Could not disburse selected loans");
          }
        })
        .catch((error) => {
          appInsights.trackException({
            exception: error,
            properties: {
              fileName: "Disburse.js",
            },
          });
          document
            .querySelector("#disbursement-loader")
            .classList.add("hidden");
          document
            .querySelector("#disbursement-error")
            .classList.remove("hidden");
          result(loans);
          this.props.onCloseModal();
          resetLoansForDisbursement();
          notification("error", "Could not disburse selected loans");
        });
    } else {
      this.setState({ error: true });
    }
  };
  disburseBatchLoan = (e) => {
    e.preventDefault();
    const { comment, selectedDate, selectedFunder } = this.state;

    if (comment && selectedDate && selectedFunder) {
      const { loans, result, resetLoansForDisbursement } =
        this.props.properties;
      const params = {
        loan_refs: loans,
        comment: comment,
        funder_id: Number(selectedFunder),
        loan_effective_date: selectedDate,
      };
      document.querySelector("#disbursement-confirm").classList.add("hidden");
      document.querySelector("#disbursement-loader").classList.remove("hidden");

      ajaxMethods
        .post(ajaxEndpoints.DISBURSE_BATCH_LOANS, params)
        .then((response) => {
          // let message = "";
          if (response.status === 200) {
            document
              .querySelector("#disbursement-loader")
              .classList.add("hidden");
            document
              .querySelector("#disbursement-success")
              .classList.remove("hidden");
            if (response?.data?.data?.success.length > 0) {
              this.setState({
                successfulApprovedBatchLoans: response.data.data.success,
              });
            }
            if (response?.data?.data?.failure.length > 0) {
              this.setState({
                failedApprovedBatchLoans: response.data.data.failure,
              });
            }
            result(loans);
            resetLoansForDisbursement();
          } else {
            document
              .querySelector("#disbursement-loader")
              .classList.add("hidden");
            document
              .querySelector("#disbursement-error")
              .classList.remove("hidden");
            result(loans);
            resetLoansForDisbursement();
            this.setState({
              errorMessage: {
                title: "Warning",
                message: response?.data?.message,
              },
            });
            setTimeout(() => {
              this.props.setToast("warning", response?.data?.message);
              return this.props.onCloseModal();
            }, 3000);
          }
        })
        .catch((error) => {
          appInsights.trackException({
            exception: error,
            properties: {
              fileName: "Disburse.js",
            },
          });
          document
            .querySelector("#disbursement-loader")
            .classList.add("hidden");
          document
            .querySelector("#disbursement-error")
            .classList.remove("hidden");
          result(loans);
          resetLoansForDisbursement();
          this.setState({
            errorMessage: {
              title: "Error",
              message: error?.response?.data?.message,
            },
          });
          setTimeout(() => {
            this.props.setToast("warning", error?.response?.data?.message);
            return this.props.onCloseModal();
          }, 3000);
        });
    }
  };
  declineBatchLoan = (e) => {
    e.preventDefault();
    const { comment } = this.state;

    if (comment) {
      const { loans, result, resetLoansForDisbursement } =
        this.props.properties;
      const params = {
        loan_refs: loans,
        comment: comment,
      };
      document.querySelector("#disbursement-confirm").classList.add("hidden");
      document.querySelector("#disbursement-loader").classList.remove("hidden");

      ajaxMethods
        .post(ajaxEndpoints.REJECT_BATCH_LOANS, params)
        .then((response) => {
          // let message = "";
          if (response.status === 200) {
            document
              .querySelector("#disbursement-loader")
              .classList.add("hidden");
            document
              .querySelector("#disbursement-success")
              .classList.remove("hidden");
            if (response?.data?.data?.success?.length > 0) {
              this.setState({
                successfulRejectedBatchLoans: response.data.data.success,
              });
            }
            if (response?.data?.data?.failure?.length > 0) {
              this.setState({
                failedRejectedBatchLoans: response.data.data.failure,
              });
            }
            result(loans);
            resetLoansForDisbursement();
          } else {
            document
              .querySelector("#disbursement-loader")
              .classList.add("hidden");
            document
              .querySelector("#disbursement-error")
              .classList.remove("hidden");
            result(loans);
            resetLoansForDisbursement();
            setTimeout(() => {
              this.props.setToast(
                "warning",
                "Unable to connect to Advancly services"
              );
              return this.props.onCloseModal();
            }, 3000);
          }
        })
        .catch((error) => {
          appInsights.trackException({
            exception: error,
            properties: {
              fileName: "Disburse.js",
            },
          });
          document
            .querySelector("#disbursement-loader")
            .classList.add("hidden");
          document
            .querySelector("#disbursement-error")
            .classList.remove("hidden");
          result(loans);
          resetLoansForDisbursement();
          setTimeout(() => {
            this.props.setToast(
              "warning",
              "Unable to connect to Advancly services."
            );
            return this.props.onCloseModal();
          }, 3000);
        });
    }
  };
  //fetch all funders
  getFunderName = () => {
    ajaxMethods
      .get(ajaxEndpoints.GET_ALL_FUNDERS)
      .then((response) => {
        let funderList = [];

        if (response.data.length > 0) {
          funderList = [...response.data];
        }
        const funderOptions = funderList.map((funder, index) => {
          const { funder_id, funder_name } = funder;
          return (
            <option key={index} id={funder_id} value={funder_id}>
              {funder_name}
            </option>
          );
        });

        this.setState({
          funderOptions: funderOptions,
        });
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "Disburse.js",
          },
        });
      });
  };

  // get comment
  //   onCommentChange = (e) => {
  //     this.setState({
  //       comment: e.target.value,
  //       error: false,
  //     });
  //   };

  handleOptionSelect = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      error: false,
    });
  };

  handleGenerateLoanSchedule = () => {
    this.props.onCloseModal();
    this.props.showModal({
      modalIdentifier: "loan",
      action: "loan_schedule",
      dataRecord: {
        amountApproved: this.props?.properties?.dataRecord?.loan_amount,
        loan_id: this.props?.properties?.dataRecord?.loan_id,
        loan_effective_date: this.state.selectedDate,
      },
    });
  };

  render() {
    const { subModal } = this.props.properties;
    const {
      comment,
      error,
      selectedFunder,
      funderOptions,
      selectedDate,
      amountApproved,
    } = this.state;
    let renderSuccessfulApprovedData,
      renderApprovedFailedData,
      renderSuccessfulRejectedData,
      renderRejectedFailedData;
    const {
      failedApprovedBatchLoans,
      successfulApprovedBatchLoans,
      failedRejectedBatchLoans,
      successfulRejectedBatchLoans,
    } = this.state;
    if (successfulApprovedBatchLoans || failedApprovedBatchLoans) {
      if (successfulApprovedBatchLoans) {
        renderSuccessfulApprovedData = (
          <div>
            <p className="text-success">
              See successful approved loans below:{" "}
            </p>
            <MDBTable responsive minimal="true" bordered hover>
              <MDBTableHead>
                <tr>
                  {/* <th style={{ width: 50 }}>S/N</th> */}
                  <th style={{ width: 50 }}>Loan Id</th>
                  <th>Message</th>
                </tr>
              </MDBTableHead>
              <MDBTableBody>
                {successfulApprovedBatchLoans.map((successfulBatchLoan) => {
                  return (
                    <tr>
                      {/* <td style={{ width: 50 }}>{successfulBatchLoan.id}</td> */}
                      <td style={{ width: 50 }}>
                        {successfulBatchLoan?.data?.data?.entityTypeId}
                      </td>
                      <td>{successfulBatchLoan?.data?.data?.message}</td>
                    </tr>
                  );
                })}
              </MDBTableBody>
            </MDBTable>
          </div>
        );
      }
      if (failedApprovedBatchLoans) {
        renderApprovedFailedData = (
          <div>
            <p className="text-danger">
              See failed approved loan reasons below:{" "}
            </p>
            <MDBTable responsive minimal="true" bordered hover>
              <MDBTableHead>
                <tr>
                  {/* <th style={{ width: 50 }}>S/N</th> */}
                  <th style={{ width: 50 }}>Loan Id</th>
                  <th>Message</th>
                </tr>
              </MDBTableHead>
              <MDBTableBody>
                {failedApprovedBatchLoans.map((failedBatchLoan) => {
                  return (
                    <tr>
                      {/* <td style={{ width: 50 }}>{failedBatchLoan.id}</td> */}
                      <td style={{ width: 50 }}>
                        {failedBatchLoan?.data?.data?.data?.entityTypeId}
                      </td>
                      <td>{failedBatchLoan?.data?.data?.message}</td>
                    </tr>
                  );
                })}
              </MDBTableBody>
            </MDBTable>
          </div>
        );
      }
    } else if (successfulRejectedBatchLoans || failedRejectedBatchLoans) {
      if (successfulRejectedBatchLoans) {
        renderSuccessfulRejectedData = (
          <div className="m-b-2 m-t-1">
            <p className="text-success">
              See successful rejected loans below:{" "}
            </p>
            <MDBTable responsive minimal="true" bordered hover>
              <MDBTableHead>
                <tr>
                  {/* <th style={{ width: 50 }}>S/N</th> */}
                  <th style={{ width: 50 }}>Loan ref</th>
                  <th>Message</th>
                </tr>
              </MDBTableHead>
              <MDBTableBody>
                {successfulRejectedBatchLoans.map(
                  (successfulRejectedBatchLoan) => {
                    return (
                      <tr>
                        {/* <td style={{ width: 50 }}>
                          {successfulRejectedBatchLoan.id}
                        </td> */}
                        <td style={{ width: 50 }}>
                          {successfulRejectedBatchLoan?.data}
                        </td>
                        <td>{successfulRejectedBatchLoan?.message}</td>
                      </tr>
                    );
                  }
                )}
              </MDBTableBody>
            </MDBTable>
          </div>
        );
      }
      if (failedRejectedBatchLoans) {
        renderRejectedFailedData = (
          <div className="m-b-2 m-t-1">
            <p className="text-danger">
              See failed rejected loans reasons below:{" "}
            </p>
            <MDBTable responsive minimal="true" bordered hover>
              <MDBTableHead>
                <tr>
                  {/* <th style={{ width: 50 }}>S/N</th> */}
                  <th style={{ width: 50 }}>Loan ref</th>
                  <th>Message</th>
                </tr>
              </MDBTableHead>
              <MDBTableBody>
                {failedRejectedBatchLoans.map((failedRejectedBatchLoan) => {
                  return (
                    <tr>
                      {/* <td style={{ width: 50 }}>
                        {failedRejectedBatchLoan.id}
                      </td> */}
                      <td style={{ width: 50 }}>
                        {failedRejectedBatchLoan?.data}
                      </td>
                      <td>{failedRejectedBatchLoan?.message}</td>
                    </tr>
                  );
                })}
              </MDBTableBody>
            </MDBTable>
          </div>
        );
      }
    }

    return (
      <div className="LoanModal Modal__content">
        <div className="Modal__body" style={{ overflow: "hidden" }}>
          {(() => {
            switch (subModal) {
              case "single":
                // Get data from component props
                const {
                  borrower_details: {
                    // borrower_id,
                    // available_balance,
                    // debt_balance,
                    first_name,
                    last_name,
                  },
                  loan_amount,
                  loan_id,
                } = this.props.properties.dataRecord;
                return (
                  <React.Fragment>
                    <h3 className="Modal__title p-b-1">Disbursement Summary</h3>
                    {/* 2. Confirm Update Role Modal*/}
                    <div id="disbursement-confirm">
                      <div className="m-b-30">
                        <h5>
                          Are you sure you want to disburse the following loan?{" "}
                        </h5>
                        <p>Borrower Name: {`${first_name} ${last_name}`}</p>
                        <p>Loan Amount: {formatMoney(loan_amount)}</p>
                        <form>
                          {error && (
                            <p className="text-danger">Field cannot be blank</p>
                          )}
                          <label style={{ width: "100%" }}>
                            Comment
                            <input
                              className="form-control"
                              name="comment"
                              value={comment}
                              onChange={(e) => this.handleOptionSelect(e)}
                            />
                          </label>
                          <label style={{ width: "100%" }}>
                            Approved Amount
                            <input
                              className="form-control"
                              name="amountApproved"
                              value={amountApproved}
                              onChange={(e) => this.handleOptionSelect(e)}
                            />
                          </label>
                          <label style={{ width: "100%", marginTop: "10px" }}>
                            Funder
                            <select
                              className="round user__form form-control"
                              name="selectedFunder"
                              id="selectedFunder"
                              value={selectedFunder}
                              onChange={(e) => this.handleOptionSelect(e)}
                            >
                              <option selected></option>
                              {funderOptions}
                            </select>
                          </label>

                          <label style={{ width: "100%", marginTop: "10px" }}>
                            Effective Date
                            <input
                              className="round user__form form-control"
                              name="selectedDate"
                              type="date"
                              id="selectedDate"
                              value={selectedDate}
                              onChange={(e) => this.handleOptionSelect(e)}
                            />
                          </label>
                          <div className="Form__action-buttons m-t-2">
                            <div>
                              <button
                                type="submit"
                                data-id={loan_id}
                                onClick={this.disburseLoan}
                                disabled={
                                  !(
                                    comment &&
                                    selectedFunder &&
                                    selectedDate &&
                                    amountApproved
                                  )
                                }
                                className="btn zoom-element login-btn m-r-1"
                              >
                                <i className="fa fa-check-circle" /> Proceed
                              </button>

                              <button
                                type="button"
                                data-id={loan_id}
                                onClick={this.handleGenerateLoanSchedule}
                                disabled={!(selectedDate && amountApproved)}
                                className="btn zoom-element btn login-btn m-0 mr-auto"
                              >
                                <i className="fa fa-clock" /> Generate Loan
                                Schedule
                              </button>
                            </div>

                            <button
                              type="button"
                              onClick={this.props.onCloseModal}
                              className="btn zoom-element btn login-btn m-0 ml-auto"
                            >
                              <i className="fa fa-times-circle" /> Cancel
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>

                    {/* 2. Disbursement Loader*/}
                    <div
                      id="disbursement-loader"
                      className="hidden loading-overlay speed-1x fadeInRight"
                    >
                      <div className=" form-loader form-loader-login verify">
                        <div className="centerLoader">
                          <div className="loading" id="adv-loader-alt" />
                          <div className="center-txt webapp-ripple-text">
                            <i className="notifier fas fa-user-cog" />
                            Processing ...
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 3. Disbursement Success Message*/}
                    <div
                      id="disbursement-success"
                      className="hidden loading-overlay speed-1x fadeInRight"
                    >
                      <div className="form-loader form-loader-login verify">
                        <div className="centerLoader">
                          <div className="loading success-loader">
                            <i className="webapp-ripple-notification success-text fa fa-check-circle" />
                          </div>
                          <div className="center-txt webapp-ripple-text">
                            <i className="notifier far fa-check-circle" />
                            Disbursement Initiated
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 4. Disbursement Error */}
                    <div
                      id="disbursement-error"
                      className="hidden loading-overlay speed-1x fadeInRight"
                    >
                      <ErrorLoader
                        icon="fas fa-wifi"
                        text="Network Issue"
                        subText="Unable to connect to Advancly services."
                      />
                    </div>
                  </React.Fragment>
                );

              case "multiple":
                const { loans, totalAmount } = this.props.properties;

                return (
                  <React.Fragment>
                    <h3 className="Modal__title p-b-1">Bulk Loans Summary</h3>

                    {/* 1. Confirm Disbursement*/}
                    <div id="disbursement-confirm">
                      <div className="m-b-6 m-r-6">
                        <p>
                          You have selected {loans.length} loans for approval
                          with reference{" "}
                          {Object.keys(loans)
                            .map(function (loan) {
                              return loans[loan];
                            })
                            .join(", ")}{" "}
                          .
                        </p>
                        <p>Total Amount is {formatMoney(totalAmount)} .</p>
                        <p>
                          Are you sure you want to disburse/decline the
                          following loans?
                        </p>
                        <form>
                          {error && (
                            <p className="text-danger">Field cannot be blank</p>
                          )}
                          <label style={{ width: "100%" }}>
                            Comment
                            <input
                              className="form-control"
                              name="comment"
                              value={comment}
                              onChange={(e) => this.handleOptionSelect(e)}
                            />
                          </label>
                          <label style={{ width: "100%", marginTop: "10px" }}>
                            Funder
                            <select
                              className="round user__form form-control"
                              name="selectedFunder"
                              id="selectedFunder"
                              value={selectedFunder}
                              onChange={(e) => this.handleOptionSelect(e)}
                            >
                              <option selected></option>
                              {funderOptions}
                            </select>
                          </label>

                          <label style={{ width: "100%", marginTop: "10px" }}>
                            Effective Date
                            <input
                              className="round user__form form-control"
                              name="selectedDate"
                              type="date"
                              id="selectedDate"
                              value={selectedDate}
                              onChange={(e) => this.handleOptionSelect(e)}
                            />
                          </label>
                          <div className="Form__action-buttons m-t-2">
                            <button
                              type="submit"
                              data-id={loan_id}
                              onClick={this.disburseBatchLoan}
                              disabled={
                                !(comment && selectedFunder && selectedDate)
                              }
                              className="btn advancly-btn m-0 mr-auto"
                            >
                              <i className="fa fa-check-circle" /> Approve
                            </button>
                            <button
                              type="submit"
                              data-id={loan_id}
                              onClick={this.declineBatchLoan}
                              disabled={!comment}
                              className="btn advancly-dimred-btn m-0 "
                            >
                              <i className="fa fa-times-circle" /> Decline
                            </button>
                            <button
                              type="button"
                              onClick={this.props.onCloseModal}
                              className="btn advancly-btn m-0 ml-auto"
                            >
                              <i className="fa fa-times" /> Cancel
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>

                    {/* 2. Disbursement Loader*/}
                    <div
                      id="disbursement-loader"
                      className="hidden loading-overlay speed-1x fadeInRight"
                    >
                      <div className=" form-loader form-loader-login verify">
                        <div className="centerLoader">
                          <div className="loading" id="adv-loader-alt" />
                          <div className="center-txt webapp-ripple-text">
                            <i className="notifier fas fa-user-cog" />
                            Processing Disbursement ...
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 3. Disbursement Success Message*/}
                    <div
                      id="disbursement-success"
                      className="hidden speed-1x fadeInRight"
                    >
                      {(successfulApprovedBatchLoans ||
                        failedApprovedBatchLoans) && (
                        <div className="m-b-3">
                          <div>
                            <div className="row m-t-2 grid__padding">
                              {successfulApprovedBatchLoans &&
                              successfulApprovedBatchLoans.length > 0 ? (
                                <div> {renderSuccessfulApprovedData} </div>
                              ) : (
                                "No Successful Approval."
                              )}
                            </div>
                            <div className="row m-t-2 grid__padding">
                              {failedApprovedBatchLoans &&
                              failedApprovedBatchLoans.length > 0 ? (
                                <div>{renderApprovedFailedData}</div>
                              ) : (
                                "No Failed Approval."
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      {(successfulRejectedBatchLoans ||
                        failedRejectedBatchLoans) && (
                        <div className="m-b-3">
                          <div>
                            <div className="row m-t-2 grid__padding">
                              {successfulRejectedBatchLoans &&
                              successfulRejectedBatchLoans.length > 0 ? (
                                <div>{renderSuccessfulRejectedData}</div>
                              ) : (
                                "No Loan was successfully Rejected."
                              )}
                            </div>
                            <div className="row m-t-2 grid__padding">
                              {failedRejectedBatchLoans &&
                              failedRejectedBatchLoans.length > 0 ? (
                                <div>{renderRejectedFailedData}</div>
                              ) : (
                                "No Failed Rejected Loan."
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="Form__action-buttons m-t-2"></div>
                      <button
                        type="button"
                        onClick={this.props.onCloseModal}
                        className="btn zoom-element btn login-btn m-0"
                      >
                        <i className="fa fa-times-circle" /> Close
                      </button>
                    </div>

                    {/* 4. Disbursement Error */}
                    <div
                      id="disbursement-error"
                      className="hidden loading-overlay speed-1x fadeInRight"
                    >
                      <ErrorLoader
                        icon="fas fa-wifi"
                        text={this.state.errorMessage?.title}
                        subText={this.state.errorMessage?.message}
                      />
                    </div>
                  </React.Fragment>
                );

              default:
                return null;
            }
          })()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    loansReducer: {
      disbursements: { records, disbursementSize, disbursementPageNumber },
    },
  } = state;
  return {
    records,
    disbursementSize,
    disbursementPageNumber,
  };
};

export default connect(mapStateToProps, {
  setToast,
  showModal,
})(Disburse);
